import styled from "styled-components";

interface IFlexFragment {
	breakpoint?: number;
}

export const FlexJustify = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const Flex = styled.div`
	display: flex;
`;

export const FlexGrow = styled.div`
	flex-grow: 1;
`;

export const FlexLeft = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
`;

export const FlexLeftWrap = styled(FlexLeft)`
	@media(max-width: 768px) {
		flex-direction:	column;
		align-items: center;
	}
`;

export const FlexRight = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;

export const FlexCenter = styled.div`
	margin: 0 auto;
	text-align: center;
`;

export const FlexColumns = styled(Flex)`
	@media(max-width: 768px) {
		flex-direction:	column;
		align-items: center;
	}
`;



// WEBPACK FOOTER //
// ./src/common/fragments/Flex.tsx